import React from "react";

export default function Testimonial() {
    return (
        <div className="cb-testimonial-section section-gap-large">
            <div className="container">
                <blockquote>
                    <h6>
                    Over the last 20 years, I've worked with many firms, onshore and offshore, and the team at Rapidops is the best that I have ever worked with.
                    </h6>
                    <div className="blockquote-author d-flex align-v-center">
                        <div className="blockquote-detail">
                            <p>Chief Information Officer</p>
                        </div>
                    </div>
                </blockquote>
            </div>
        </div>
    );
}
